import { useContext } from "react";
import H3 from "../../../elements/titles/H3";
import usersContext from "../../../../dataManager/context/usersContext";
import UserLoaderBox from "../../../utils/loadersBox/UserLoaderBox";
import UserBox from "./components/UserBox";

const UsersSubscribed = () => {
  //context variables
  const { users } = useContext(usersContext);

  const usersOrUsersLoaders = users.length
    ? users.map((user) => <UserBox user={user} />)
    : [1, 2, 3, 4, 5, 6].map((arg) => <UserLoaderBox classe=" p-3" />);

  return (
    <div className="mt-10 h-auto max-h-[500px]  w-full rounded border border-secondary/80 md:mt-0 md:w-96">
      <div className="bg-primary p-3">
        <H3 classe="text-white">
          Liste des utilisateurs inscripts que vous n'avez pas encore contactés
        </H3>
      </div>
      <div className="flex h-[450px] flex-col   divide-y divide-secondary/80 overflow-y-auto ">
        {usersOrUsersLoaders}
      </div>
    </div>
  );
};

export default UsersSubscribed;
